import React from 'react';
import PropTypes from 'prop-types';
import { StyledTHead, StyledTh } from './Table.styles';

const TableHeader = ({
  formatHeader = ({ key }) => key,
  columns,
  headerBackground,
  headerColor,
  onHeaderClick = () => {},
  sortable,
  headerHeight
}) => (
  <StyledTHead {...{ headerBackground, headerColor }}>
    <tr>
      {columns.map((column) => (
        <StyledTh
          onClick={() => onHeaderClick(column.key)}
          headerColor={column.headerColor}
          columnBackgroundColor={column.columnBackgroundColor}
          columnColor={column.columnColor}
          key={column.key}
          sortable={sortable}
          headerHeight={headerHeight}
        >
          {formatHeader(column)}
        </StyledTh>
      ))}
    </tr>
  </StyledTHead>
);

TableHeader.propTypes = {
  headerBackground: PropTypes.object,
  headerColor: PropTypes.string,
  sortable: PropTypes.bool,
  onHeaderClick: PropTypes.func,
  sortKey: PropTypes.string,
  sortOrderIsAscending: PropTypes.bool,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      format: PropTypes.func,
      key: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  headerHeight: PropTypes.number,
  formatHeader: PropTypes.func
};

export default TableHeader;
